export const PrequalificationRouteInformation = {
  INDEX: {
    label: 'component.page_header.prequalifications',
    navigationPath: () => '/prequalifications/local',
    routePath: '/local',
  },
  NEW_RESOURCE_SET: {
    label: 'prequalifications.resource_set.new.title',
    navigationPath: () => '/prequalifications/local/new',
    routePath: '/local/new',
  },
  RESOURCE_SET_DETAILS: {
    label: 'component.page_header.prequalifications',
    navigationPath: (resourceSetId: string) => `/prequalifications/local/${resourceSetId}`,
    routePath: '/local/:resourceSetId',
  },
  EDIT_RESOURCES: {
    label: 'prequalifications.resource_set.edit_resources.title',
    navigationPath: (resourceSetId: string) => `/prequalifications/local/${resourceSetId}/resources`,
    routePath: '/local/:resourceSetId/resources',
  },
} as const

export const LOCAL_PQ_PLAYBOOK_URL =
  'https://app.notion.com/p/sympower/Playbook-Running-a-local-PQ-in-Flex-Portal-3e428c3d46fa813a918ef90363201bea'
